import React, { useState, useContext, useEffect } from 'react'
import { Card, CardBody, CardFooter, CardTitle, Row, Col, Button, InputGroup, InputGroupText, Alert, Label, FormGroup, Input, } from "reactstrap";
import { AppContext } from '../../AppContext';
import Hide from '../../assets/img/icon/hide.png'
import View from '../../assets/img/icon/view.png'
import axios from 'axios';
import { Form, Link, useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from '../../constants';
import Logo from '../../assets/img/inspectalyLogo.png'

const ResetPassword = () => {
    const [errMsg, setErrMsg] = useState(null);
    const [isValidToken, setIsValidToken] = useState(null);
    const [visible, setVisible] = useState(false);
    const { token } = useParams();
    console.log(isValidToken, 'isValidToken')
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [visibleNew, setVisibleNew] = useState(false);
    const [visibleConfirm, setVisibleConfirm] = useState(false);

    const navigate = useNavigate();

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        if (name === 'newPassword') setNewPassword(value);
        if (name === 'confirmPassword') setConfirmPassword(value);
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();

        try {

            const response = await axios.post(`${BASE_URL}/auth/reset-password/${token}`, {
                new_password: newPassword,
                confirm_password: confirmPassword
            });
            console.log(response.data, 'shamp')
            if (response.data.status) {
                navigate('/login')
            }
            else {
                setErrMsg(response?.data?.message);
            }
        } catch (error) {
            setErrMsg(error);
        }

    };

    const show = () => {
        if (visible === false) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    };

    const fetchData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/auth/validate-token/${token}`);
            console.log(response.data, 'eng');
            if (!response.data.status) {
                setIsValidToken(response?.data?.message);
            }
        } catch (error) {
            setIsValidToken("An error occurred");
        }
    };

    useEffect(() => {
        fetchData();
    }, [token]);

    return (
        <div style={{ minHeight: '100vh', background: 'rgb(244, 243, 239)', paddingTop: '5%' }} >
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img src={Logo} alt="Logo" width="250" height="auto" draggable="false" />
            </div>
            {isValidToken === null ?
                <Card
                    style={{
                        width: '90%',
                        maxWidth: '30rem',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        padding: '20px',
                        paddingBottom: '40px',
                    }}>
                    {errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

                    <CardBody>
                        <CardTitle tag="h3" className='text-center mb-4'>
                            Reset Password
                        </CardTitle>
                        <CardTitle>
                            New Password
                        </CardTitle>
                        <InputGroup>
                            <Input
                                type={visibleNew ? "text" : "password"}
                                name="newPassword"
                                id="newPassword"
                                value={newPassword}
                                onChange={handlePasswordChange}
                                className="form-control user-select-none"
                            />
                            <InputGroupText
                                onClick={() => setVisibleNew(!visibleNew)}
                                className="user-select-none"
                            >
                                {visibleNew ? (
                                    <img src={View} alt="Show" height={20} draggable="false" />
                                ) : (
                                    <img src={Hide} alt="Hide" height={20} draggable="false" />
                                )}
                            </InputGroupText>
                        </InputGroup>


                        <CardTitle>
                            Confirm Password
                        </CardTitle>
                        <InputGroup>
                            <Input
                                type={visibleConfirm ? "text" : "password"}
                                name="confirmPassword"
                                id="confirmPassword"
                                value={confirmPassword}
                                onChange={handlePasswordChange}
                                className="form-control user-select-none"
                            />
                            <InputGroupText
                                onClick={() => setVisibleConfirm(!visibleConfirm)}
                                className="user-select-none"
                            >
                                {visibleConfirm ? (
                                    <img src={View} alt="Show" height={20} draggable="false" />
                                ) : (
                                    <img src={Hide} alt="Hide" height={20} draggable="false" />
                                )}
                            </InputGroupText>
                        </InputGroup>
                    </CardBody>

                    <CardFooter className=''>
                        <Row className='text-center'>
                            <Col >
                                <Button color="primary" className='px-5' size="md" onClick={handleResetPassword} >Confirm</Button>
                            </Col>
                        </Row>
                    </CardFooter>
                </Card>
                :
                <Card
                    style={{
                        width: '90%',
                        maxWidth: '30rem',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        padding: '20px',
                        paddingBottom: '40px',
                    }}>
                    {errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

                    <CardBody>
                        <CardTitle tag="h3" className='text-center mb-4'>
                            Reset Password
                        </CardTitle>

                        <h6 className="text-center" style={{ marginTop: '60px' }}> {isValidToken}</h6>
                    </CardBody>


                </Card>
            }
        </div>
    )
}

export default ResetPassword
